import httpClient from "@/api/httpClient";
import {
  IDistributorListResponse,
  IDistributorResponse,
  ICommonDistributor,
  ISearchDistributorResponse,
} from "./distributors.interfaces";

export const getDistributorsService = async (
  page: number = 0,
  limit: number = 10,
  sort: string = "",
  order: "asc" | "desc" | "" = "",
  search: string = ""
): Promise<IDistributorListResponse> => {
  try {
    const params: any = {
      page,
      limit,
    };

    if (sort) {
      params.sort = sort;
    }
    if (order) {
      params.order = order;
    }
    if (search) {
      params.search = search;
    }

    const response = await httpClient.get("/v1/distributor", { params });
    return response.data;
  } catch (e) {
    throw e;
  }
};

export const getDistributorService = async (
  id: string
): Promise<IDistributorResponse> => {
  try {
    const response = await httpClient.get(`/v1/distributor/${id}`);
    return response.data;
  } catch (e) {
    throw e;
  }
};

export const addDistributorService = async (
  distributor: ICommonDistributor
): Promise<IDistributorResponse> => {
  try {
    const response = await httpClient.post("/v1/distributor", distributor);
    return response.data;
  } catch (e) {
    throw e;
  }
};

/**
 * Update a distributor
 *
 * @param id The ID of the distributor to update
 * @param distributor The distributor data to update with
 * @returns The updated distributor
 * @throws An error if the API request fails
 */
export const updateDistributorService = async (
  id: string,
  distributor: ICommonDistributor
): Promise<IDistributorResponse> => {
  try {
    const response = await httpClient.patch(
      `/v1/distributor/${id}`,
      distributor
    );
    return response.data;
  } catch (e) {
    throw e;
  }
};

export const deleteDistributorService = async (
  id: string
): Promise<IDistributorResponse> => {
  try {
    const response = await httpClient.delete(`/v1/distributor/${id}`);
    return response.data;
  } catch (e) {
    throw e;
  }
};

export const searchDistributorService = async (
  search: string
): Promise<ISearchDistributorResponse[]> => {
  try {
    const response = await httpClient.get(`/v1/distributor/search`, {
      params: { q: search },
    });
    return response.data;
  } catch (e) {
    throw e;
  }
};
